import { render, staticRenderFns } from "./CloudflareStatusAlert.vue?vue&type=template&id=bc037a6c"
import script from "./CloudflareStatusAlert.vue?vue&type=script&lang=js"
export * from "./CloudflareStatusAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports